// import api from "../api";
// import { GET_PUBLIC_POST_DETAILS, GET_PUBLIC_POST,GET_NAVBAR_MENULIST,GET_PUBLIC_LACAL_NEWS,POST_COMMENT,LATEST_POST,MORE_POST, CATEGORY_DETAIL, GLOBAL_SEARCH, FOR_YOU_DATA, YOUR_TOPIC_DATA, PICK_FOR_YOU_DATA, SHOW_TOSTER, STORE_COMMENT, GET_BACK_TO_DETAILS } from "./type";

import { useNavigate } from "react-router-dom";
import api from "../api";
import { ELECTORAL_VOTES,SET_LOADING, CLEAR_LOADING, POLLING_TABLE_LIST, POLLS_AVERAGE_DATA, DELHI_TABLE_LIST, INDIA_POLL_TYPE_LIST, DELHI_POLL_YEARS_LIST, VOTER_CATEGORY_LIST, GET_PARTY_LIST, ADD_PREDICTION_DATA, PREDICTION_LISTING_DATA, RESET_RESPONSE, PREDICTION_DATA_BY_ID, UPDATE_PREDICTION_DATA, SELECT_PREDICTION_LISTING_DATA, PREVIOUS_PREDICTION_LISTING_DATA, ADD_PREDICTION_POST_DATA, PREDICTION_POST_LISTING_DATA, PREDICTION_POST_LIKE_UNLIKE, PREDICTION_POST_FOLLOW_UNFOLLOW, PREDICTION_POST_COMMENT, PREDICTION_POST_DETAIL_DATA, COPY_BEST_POLLSTER, GET_SEGMENT_MODIFIOCATION_TYPE, POLLSTER_PREDICTION_LISTING_DATA, COPIED_POLLSTER_PREDICTION_DATA, FOLLOWED_PREDICTION_POST_LISTING_DATA, CANADA_TABLE_LIST, CANADA_POLL_YEARS_LIST, INDIA_STATE_LIST, PARTY_META_DATA, ELECTORAL_VOTES_AVERAGE, STATE_COUNTRY } from "./type";

const withLoading = async (dispatch, asyncFn) => {
  dispatch({ type: SET_LOADING });
  try {
    const result = await asyncFn();
    return result;
  } finally {
    dispatch({ type: CLEAR_LOADING });
  }
};

export const getPollingTableList = (payload, candidateName) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/polls/view?${payload}&candidateName=${candidateName}`);
    if (response?.status === 200) {
      dispatch({ type: POLLING_TABLE_LIST, payload: response?.data });
    } else if (response?.status === 401) {
      localStorage.removeItem("accessToken")
    }
   return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }

  }
  });
};

export const getIndiaPolltypes = () => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/get-poll-types/view/india`);
    if (response.status === 200) {
      dispatch({ type: INDIA_POLL_TYPE_LIST, payload: response?.data })
    }
    else if (response.status === 401) {
      localStorage.removeItem("accessToken");
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.error(error);

  }
  });
}

export const getStatesConsistuency = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/states-consistuency/view`, payload);
    if (response.status === 200) {
      dispatch({ type: INDIA_STATE_LIST, payload: response?.data })
    }
    else if (response.status === 401) {
      localStorage.removeItem("accessToken");
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.error(error);

  }
  });
}





export const getPartyMetaData = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/election-parties/view`, payload);
    if (response?.status === 200) {
      dispatch({ type: PARTY_META_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    // console.log('error', error.response.status)
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}





// Delhi Polls Actions 


export const getPolls = (payload, params) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/polls/view${params ? `?${params}` : ""}`, payload);
    if (response?.status === 200) {
      dispatch({ type: DELHI_TABLE_LIST, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getStateCountry = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/get/state-country`, payload);
    if (response?.status === 200) {
      dispatch({ type: STATE_COUNTRY, payload: response?.data });
      localStorage.setItem("country", response?.data.country_id);
      localStorage.setItem("state", response?.data.state_id);
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    // console.log('error', error.response.status)
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getPollsYears = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/polls/year-list`, payload);
    if (response?.status === 200) {
      dispatch({ type: DELHI_POLL_YEARS_LIST, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    // console.log('error', error.response.status)
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getPollsAverage = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/polls/calculate-poll-average`, payload);
    if (response?.status === 200) {
      dispatch({ type: POLLS_AVERAGE_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")
    }
   return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
};
// export const getElectoralVotes = (payload) => async (dispatch) => {
//  return withLoading(dispatch, async () => {
  // try {
//     const response = await api.get(`/user/polls/candidate-list`, payload);
//     if (response?.status === 200) {
//       dispatch({ type: ELECTORAL_VOTES, payload: response?.data });
//     }
//     else if (response?.status === 401) {
//       localStorage.removeItem("accessToken")
//     }
//     else {
//     }
//   } catch (error) {
//     if (error?.response?.status === 401) {
//       localStorage.removeItem("accessToken")
//       localStorage.removeItem("email")
//       alert("Session expired. Please log in again.")
//       window.location.href = "/login"
//     }

//   }
// };

export const getElectoralVotes = (payload, params) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/election-candidate/view${params ? `?${params}` : ""}`, payload);
    if (response?.status === 200) {
      dispatch({ type: ELECTORAL_VOTES, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")
    }
   return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }

  }
  });
};

// Canada Polls Actions

export const getCanadaPolls = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/canada-polls/view?${payload ? payload : ""}`);
    if (response?.status === 200) {
      dispatch({ type: CANADA_TABLE_LIST, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")
    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getCanadaPollsYears = () => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/canada-polls/year-list`);
    if (response?.status === 200) {
      dispatch({ type: CANADA_POLL_YEARS_LIST, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}

// India Prediction Actions 

export const getVoterCategoryList = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/voter-category/view`, payload);
    if (response?.status === 200) {
      dispatch({ type: VOTER_CATEGORY_LIST, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")
    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getCopyPolster = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/pollster-category/view/${payload}`);
    if (response?.status === 200) {
      dispatch({ type: COPY_BEST_POLLSTER, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")
    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getPartyList = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/prediction-header/view`, payload);
    if (response?.status === 200) {
      dispatch({ type: GET_PARTY_LIST, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getSegmentModificationType = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/prediction-modification/view`);
    if (response?.status === 200) {
      dispatch({ type: GET_SEGMENT_MODIFIOCATION_TYPE, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const addUserPrediction = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/user-prediction/add`, payload);
    if (response?.status === 201) {
      dispatch({ type: ADD_PREDICTION_DATA, payload: response?.data });
      // console.log("logging from action ", response?.data);

    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const addPredictionPost = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/user-post/add`, payload);
    if (response?.status === 201) {
      dispatch({ type: ADD_PREDICTION_POST_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const updateUserPrediction = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.put(`/user/user-prediction/edit`, payload);
    if (response?.status === 200) {
      dispatch({ type: UPDATE_PREDICTION_DATA, payload: response?.data });
      console.log("logging from action ", response?.data);

    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
    else {
      // console.log("")
    }
    return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
    // console.log(error);

  }
  });
}
export const getUserPrediction = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/user-prediction/view`);
    if (response?.status === 200) {
      dispatch({ type: PREDICTION_LISTING_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
// export const getPollsterPrediction = (payload, countryId) => async (dispatch) => {
//  return withLoading(dispatch, async () => {
//   try {
//     const response = await api.post(`/user/poll-analysis/view`, payload);
//     if (response?.status === 200) {
//       dispatch({ type: POLLSTER_PREDICTION_LISTING_DATA, payload: response?.data });
//     }
//     else if (response?.status === 401) {
//       localStorage.removeItem("accessToken")

//     }
//    return response;
//   }
//   catch (error) {
//     if (error?.response?.status === 401) {
//       localStorage.removeItem("accessToken")
//       localStorage.removeItem("email")
//       alert("Session expired. Please log in again.")
//       window.location.href = "/login"
//     }
//   }
//   });
// }
export const getPollsterPrediction = (payload, countryId) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/poll-analysis/view`, payload);
    if (response?.status === 200) {
      dispatch({ type: POLLSTER_PREDICTION_LISTING_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const getFollowedPredictionPost = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    let filterQuery = "";

    if (Array.isArray(payload.payload) && payload.payload.length > 0) {
      filterQuery = payload.payload.map(filter => `filter=${filter}`).join("&");
    }
    let search = payload.search ? `search=${payload.search}` : ""
    let finalQuery = ""
    if (search && filterQuery) {
      finalQuery = `?${search}&${filterQuery}`
    }
    else if (search) {
      finalQuery = `?${search}`
    }
    else if (filterQuery) {
      finalQuery = `?${filterQuery}`
    }

    const response = await api.get(`/user/my-followed-prediction/view${finalQuery}`);
    if (response?.status === 200) {
      dispatch({ type: FOLLOWED_PREDICTION_POST_LISTING_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const getUserPredictionPost = (payload) => {
  console.log("🚀 ~ getUserPredictionPost ~ payload:", payload)
  return async (dispatch) => {
  return withLoading(dispatch, async () => {
    try {
      let finalQueryParts = [];

      // search
      if (payload.search) finalQueryParts.push(`search=${payload.search}`);

      // country
      if (payload.country) finalQueryParts.push(`country=${payload.country}`);

      // year
      if (payload.year) finalQueryParts.push(`year=${payload.year}`);

      // state
      if (payload.state) finalQueryParts.push(`state=${payload.state}`);
      if (payload.type) finalQueryParts.push(`type=${payload.type}`);

      // filters
      if (Array.isArray(payload.payload) && payload.payload.length > 0) {
        payload.payload.forEach((f) => {
          finalQueryParts.push(`filter=${f}`);
        });
      }

      // build final query
      let finalQuery =
        finalQueryParts.length > 0 ? `?${finalQueryParts.join("&")}` : "";

      const response = await api.get(`/user/user-post/view${finalQuery}`);

      if (response?.status === 200) {
        dispatch({
          type: PREDICTION_POST_LISTING_DATA,
          payload: response.data,
        });
      } else if (response?.status === 401) {
        localStorage.removeItem("accessToken");
      }

      return response;
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("email");
        alert("Session expired. Please log in again.");
        window.location.href = "/login";
      }
    }
  });
};
};

export const addUserPredictionPostLikeUnlike = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/post/like-unlike`, payload);
    if (response?.status === 200) {
      dispatch({ type: PREDICTION_POST_LIKE_UNLIKE, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const addUserPredictionPostComment = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`user/post-comment/add`, payload);
    if (response?.status === 200) {
      dispatch({ type: PREDICTION_POST_COMMENT, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const getUserPredictionPostDetails = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/user-post/view/${payload}`);
    if (response?.status === 200) {
      dispatch({ type: PREDICTION_POST_DETAIL_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const addUserPredictionPostFollowUnfollow = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/follow-unfollow/add`, payload);
    if (response?.status === 200) {
      dispatch({ type: PREDICTION_POST_FOLLOW_UNFOLLOW, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const getPreviousUserPrediction = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/user-prediction/previous`, payload);
    if (response?.status === 200) {
      dispatch({ type: PREVIOUS_PREDICTION_LISTING_DATA, payload: response?.data });
      if (response?.data?.msg === "No previous predictions found for this country.") {
        alert(response?.data?.msg)
        window.location.href = "/prediction"
      }
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const getElectoralVotesAverage = (payload, params) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/polls/electoral-votes-average${params ? `?${params}` : ""}`, payload);
    if (response?.status === 200) {
      // if (response?.data?.msg === "No previous predictions found for this country.") {
      //   alert(response?.data?.msg)
      //   window.location.href = "/prediction"
      // }
      dispatch({ type: ELECTORAL_VOTES_AVERAGE, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const getCopiedPollsterPrediction = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.post(`/user/user-prediction/best-and-average`, payload);
    if (response?.status === 200) {
      dispatch({ type: COPIED_POLLSTER_PREDICTION_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const getUserPredictionById = (payload) => async (dispatch) => {
  // console.log('payload', payload)
 return withLoading(dispatch, async () => {
  try {
    let filterQuery = "";

    if (Array.isArray(payload.payload) && payload.payload.length > 0) {
      filterQuery = payload.payload.map(filter => `filter=${filter}`).join("&");
    }
    const response = await api.get(
      `/user/user-prediction/view/${payload.id}${filterQuery ? `?${filterQuery}` : ""}`
    );
    if (response?.status === 200) {
      dispatch({ type: PREDICTION_DATA_BY_ID, payload: response?.data });
    } else if (response?.status === 401) {
      localStorage.removeItem("accessToken");
    }
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
};
export const geSelectPrediction = (payload) => async (dispatch) => {
 return withLoading(dispatch, async () => {
  try {
    const response = await api.get(`/user/prediction-selection/view`);
    if (response?.status === 200) {
      dispatch({ type: SELECT_PREDICTION_LISTING_DATA, payload: response?.data });
    }
    else if (response?.status === 401) {
      localStorage.removeItem("accessToken")

    }
   return response;
  }
  catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken")
      localStorage.removeItem("email")
      alert("Session expired. Please log in again.")
      window.location.href = "/login"
    }
  }
  });
}
export const resetPollFields = () => ({
  type: RESET_RESPONSE
})


